// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Streamdown style overrides for the documentation page renderer.
 *
 * Scoped to .docs-streamdown so these rules don't conflict with the
 * chat page's .chat-streamdown overrides.
 *
 * Mirrors the chat overrides in dev-agent/components/streamdownOverrides.css
 * but targets .docs-streamdown instead of .chat-streamdown.
 */

/* Strip outer container borders/backgrounds to avoid "box inside a box". */
.docs-streamdown [data-streamdown\$="-block"],
.docs-streamdown [data-streamdown\$="-wrapper"] {
  border: 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  padding: 0 !important;
  gap: 0.25rem !important;
}

/* Each diagram is its own stacking/layout boundary. */
.docs-streamdown [data-streamdown="mermaid"] {
  isolation: isolate;
  contain: layout style;
}

/* Force mermaid SVGs to full-width with a sensible minimum height. */
.docs-streamdown [data-streamdown="mermaid"] > *,
.docs-streamdown [aria-label="Mermaid chart"] {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
}
.docs-streamdown [data-streamdown="mermaid"] svg {
  width: 100% !important;
  height: auto !important;
  min-height: 400px !important;
  max-width: none !important;
}

/* Reset SVG sizing for icon buttons inside the zoom/pan controls overlay. */
.docs-streamdown [data-streamdown="mermaid"] button svg {
  width: 1rem !important;
  height: 1rem !important;
  min-width: unset !important;
  min-height: unset !important;
  max-width: unset !important;
}

/* Tables — add subtle grid borders for visual structure. */
.docs-streamdown [data-streamdown="table-cell"],
.docs-streamdown [data-streamdown="table-header-cell"] {
  border: 1px solid hsl(var(--border) / 0.3) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/documentation/streamdownOverrides.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF,2EAA2E;AAC3E;;EAEE,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,qEAAqE;AACrE;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,4EAA4E;AAC5E;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,2DAA2D;AAC3D;;EAEE,qDAAqD;AACvD","sourcesContent":["/*\n * Streamdown style overrides for the documentation page renderer.\n *\n * Scoped to .docs-streamdown so these rules don't conflict with the\n * chat page's .chat-streamdown overrides.\n *\n * Mirrors the chat overrides in dev-agent/components/streamdownOverrides.css\n * but targets .docs-streamdown instead of .chat-streamdown.\n */\n\n/* Strip outer container borders/backgrounds to avoid \"box inside a box\". */\n.docs-streamdown [data-streamdown$=\"-block\"],\n.docs-streamdown [data-streamdown$=\"-wrapper\"] {\n  border: 0 !important;\n  background: transparent !important;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  gap: 0.25rem !important;\n}\n\n/* Each diagram is its own stacking/layout boundary. */\n.docs-streamdown [data-streamdown=\"mermaid\"] {\n  isolation: isolate;\n  contain: layout style;\n}\n\n/* Force mermaid SVGs to full-width with a sensible minimum height. */\n.docs-streamdown [data-streamdown=\"mermaid\"] > *,\n.docs-streamdown [aria-label=\"Mermaid chart\"] {\n  display: block !important;\n  width: 100% !important;\n  max-width: none !important;\n}\n.docs-streamdown [data-streamdown=\"mermaid\"] svg {\n  width: 100% !important;\n  height: auto !important;\n  min-height: 400px !important;\n  max-width: none !important;\n}\n\n/* Reset SVG sizing for icon buttons inside the zoom/pan controls overlay. */\n.docs-streamdown [data-streamdown=\"mermaid\"] button svg {\n  width: 1rem !important;\n  height: 1rem !important;\n  min-width: unset !important;\n  min-height: unset !important;\n  max-width: unset !important;\n}\n\n/* Tables — add subtle grid borders for visual structure. */\n.docs-streamdown [data-streamdown=\"table-cell\"],\n.docs-streamdown [data-streamdown=\"table-header-cell\"] {\n  border: 1px solid hsl(var(--border) / 0.3) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
